"use client";

import DelayedRender from "@/components/DelayedRender";
import DishIcon from "@/components/svg/DishIcon";
import {
  CalendarDaysIcon,
  CalendarIcon,
  ClipboardDocumentListIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";
import CheckIfTrial from "@/components/CheckIfTrial";
import Classes from "@/components/Classes";
import ClientSide from "@/components/ClientSide";
import Orders from "@/components/Orders";
import { UserContext } from "@/components/Page";
import Head from "next/head";
import Link from "next/link";

export default function Home() {
  return (
    <CheckIfTrial>
      <>
        <Head>
          <title>Home | ClassCart</title>
        </Head>
        <div>
          <UserContext.Consumer>
            {(user) => (
              <>
                {/* <div className="group relative mt-10 mb-20 block max-w-6xl overflow-hidden rounded-lg bg-gradient-to-tr from-green-50 to-cyan-50 p-14 shadow-lg transition-shadow hover:shadow-xl">
                    <span className="tag tag-primary ttext-green-600 ml-0">
                      new in beta
                    </span>
                    <h1 className="mb-8 flex items-center gap-1.5 font-medium text-green-600">
                      Recipe File Upload
                    </h1>
                    <p className="mb-4 text-xl font-normal text-green-900">
                      It&apos;s been a long time coming, and it&apos;s finally
                      here. You can now upload recipes directly from images,
                      PDFs, and Word documents!
                    </p>
                    <Link prefetch={false} href="/create-recipe?method=file" className="btn btn-primary mx-0 font-medium">
                        Check It Out!
                    </Link>

                    <DelayedRender delay={3 * 1000}>
                      <div className="absolute -top-6 -right-6 animate-float opacity-50 transition-all duration-500 group-hover:opacity-100">
                        <img
                          src="https://foodhub.scene7.com/is/image/woolworthsltdprod/healthier-easier-banner-asparagus-pasta-salad-recipe-half-width:DesktopHalfWidth-1300x935"
                          alt="recipe image"
                          className="w-32 rotate-12 transform rounded-3xl"
                        />
                      </div>
                    </DelayedRender>

                    <DelayedRender delay={0.5 * 1000}>
                      <div className="absolute -top-16 -left-2 animate-float opacity-50 transition-all duration-500 group-hover:opacity-100">
                        <img
                          src="https://foodhub.scene7.com/is/image/woolworthsltdprod/0422-roasted-eggplant-and-tomato-pasta:Square-1300x1300?wid=1300&hei=1300"
                          alt="recipe image"
                          className="w-24 -rotate-12 transform rounded-3xl"
                        />
                      </div>
                    </DelayedRender>

                    <DelayedRender delay={5 * 1000}>
                      <div className="absolute -bottom-40 left-1/2 animate-float opacity-50 transition-all duration-500 group-hover:opacity-100">
                        <img
                          src="https://foodhub.scene7.com/is/image/woolworthsltdprod/2011-quick-roast-pork-with-potato-and-slaw-salad:Square-1300x1300?wid=1300&hei=1300"
                          alt="recipe image"
                          className="w-44 -translate-y-12 rotate-12 transform rounded-3xl"
                        />
                      </div>
                    </DelayedRender>
                  </div> */}
                <div className="xp-14 xblock group relative mb-20 mt-10 hidden max-w-3xl overflow-hidden rounded-lg bg-gradient-to-tr from-green-50 to-cyan-50 p-6 shadow-lg transition-shadow hover:shadow-xl print:hidden">
                  <span className="tag tag-cyan ttext-green-600 ml-0">
                    coming soon
                  </span>
                  <h1 className="xmb-8 mb-4 flex items-center gap-1.5 font-medium text-green-600">
                    New Pricing Plan
                  </h1>
                  <p className="mb-4 text-xl font-normal text-green-900">
                    We&apos;re working on a new pricing plan that will make
                    ClassCart more accessible to smaller schools. It will be
                    coming into effect on the 16th of September.
                  </p>
                  {/* <Link
                      prefetch={false}
                      href="/settings#deadlines"
                      className="btn btn-primary mx-0 font-medium"
                    >
                      Start Setting Deadlines
                    </Link> */}
                  <a
                    href="https://www.classcart.com/blog/pricing-plans-2024"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary mx-0 font-medium"
                  >
                    Read More
                  </a>

                  <DelayedRender delay={3 * 1000}>
                    <div className="absolute -right-6 -top-6 hidden animate-float opacity-50 transition-all duration-500 group-hover:opacity-100">
                      {/* <img
                          src="https://foodhub.scene7.com/is/image/woolworthsltdprod/healthier-easier-banner-asparagus-pasta-salad-recipe-half-width:DesktopHalfWidth-1300x935"
                          alt="recipe image"
                          className="w-32 rotate-12 transform rounded-3xl"
                        /> */}
                      <ClockIcon className="w-32 rotate-12 transform" />
                    </div>
                  </DelayedRender>

                  <DelayedRender delay={0.5 * 1000}>
                    <div className="absolute -left-2 -top-16 hidden animate-float opacity-50 transition-all duration-500 group-hover:opacity-100">
                      {/* <img
                          src="https://foodhub.scene7.com/is/image/woolworthsltdprod/0422-roasted-eggplant-and-tomato-pasta:Square-1300x1300?wid=1300&hei=1300"
                          alt="recipe image"
                          className="w-24 -rotate-12 transform rounded-3xl"
                        /> */}
                      <DishIcon className="w-24 -rotate-12 transform" />
                    </div>
                  </DelayedRender>

                  <DelayedRender delay={5 * 1000}>
                    <div className="absolute -bottom-30 left-1/2 hidden animate-float opacity-50 transition-all duration-500 group-hover:opacity-100">
                      {/* <img
                          src="https://foodhub.scene7.com/is/image/woolworthsltdprod/2011-quick-roast-pork-with-potato-and-slaw-salad:Square-1300x1300?wid=1300&hei=1300"
                          alt="recipe image"
                          className="w-44 -translate-y-12 rotate-12 transform rounded-3xl"
                        /> */}
                      <CalendarDaysIcon className="w-44 -translate-y-12 rotate-12 transform" />
                    </div>
                  </DelayedRender>
                </div>

                <div className="screen:space-y-30">
                  <div className="mb-20 mt-20 flex flex-wrap items-center gap-8 print:hidden">
                    {user.school?.plan !== "basic" ? (
                      <Link
                        prefetch={false}
                        href="/schedule"
                        className="group relative block max-w-md transform overflow-hidden rounded-lg bg-gradient-to-tr from-green-50 to-cyan-50 p-5 pl-5 shadow-md transition hover:shadow-lg"
                      >
                        <h1 className="mb-8 text-3xl font-medium text-cyan-600">
                          Schedule
                        </h1>
                        <div className="text-xl font-normal text-cyan-900">
                          Manage lessons &amp; orders in various calendar views.
                        </div>

                        <div className="absolute -right-3 -top-3 transform transition duration-500 group-hover:scale-110">
                          <CalendarIcon className="w-24 rotate-12 transform text-cyan-700/50 transition duration-500 group-hover:text-cyan-700" />
                        </div>
                      </Link>
                    ) : null}

                    <Link
                      prefetch={false}
                      href="/shopping-list"
                      className="group relative block max-w-md transform overflow-hidden rounded-lg bg-gradient-to-tr from-green-50 to-cyan-50 p-5 pl-5 shadow-md transition hover:shadow-lg"
                    >
                      <h1 className="mb-8 text-3xl font-medium text-cyan-600">
                        Shopping List
                      </h1>
                      <div className="text-xl font-normal text-cyan-900">
                        A collated list of ingredients ordered in all (or some)
                        classes.
                      </div>

                      <div className="absolute -right-6 -top-6 transform transition duration-500 group-hover:scale-110">
                        <ClipboardDocumentListIcon className="w-30 rotate-12 transform text-cyan-700/50 transition duration-500 group-hover:text-cyan-700" />
                      </div>
                    </Link>
                  </div>
                  <ClientSide>
                    <>
                      <Classes user={user} />
                      <Orders user={user} />
                    </>
                  </ClientSide>
                </div>
              </>
            )}
          </UserContext.Consumer>
        </div>
      </>
    </CheckIfTrial>
  );
}
